import { DialogActions, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { PhoneNumberModel } from '../../models/phone-number.model';
import { PlanModel } from '../../models/plans.model';
import { PlanHistoryModel } from '../../models/transaction-history.model';
import { appNote, DialogHeaders } from '../shared/constants';
import PlanDetails from '../shared/plan-details.component';
import { CancelIcon, BackMobileIcon, BackIcon } from '../../icon';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors";

interface Props {
	Open: boolean;
	HandleClose: () => void;
	CurrentPlan?: PlanHistoryModel;
	CurrentPhoneNumber?: PhoneNumberModel;
	CurrentAddons?: PlanModel[];
	IsMobileDevice: boolean;
}
const CurrentPlanDetails: React.FC<Props> = (props: Props) => {
	const IsDarkMode: boolean = useSelector(selector.isDarkMode)

	return (
		!props.IsMobileDevice ?
			<Dialog
				maxWidth='md'
				open={props.Open}
				onClose={props.HandleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"

				disableEscapeKeyDown
				BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: `w-66 br-2 ${IsDarkMode ? "bg-color-sidebar-bg" : "dialogue-shadow"}` }}
			>
				<DialogTitle id="alert-dialog-title">
					<div className="h2-regular color-text-field-font d-flex">
						{!!props.CurrentPlan ? DialogHeaders.PLAN_DETAILS : DialogHeaders.CURRENT_PLAN_DETAILS}
						<Tooltip title='Close' placement='bottom'>
							<span className={"ml-auto"}>
								<CancelIcon className={"c-pointer"} onClick={props.HandleClose} />
							</span>
						</Tooltip>
					</div>
				</DialogTitle>
				<DialogContent className={`mh-v-60 pb-0`}>
					{!!props.CurrentPlan || !!props.CurrentAddons ?
						<PlanDetails currentPlan={props.CurrentPlan?.Plan} currentPhoneNumber={props.CurrentPhoneNumber}
							CurrentAddons={props.CurrentAddons}
							transactionHistory={props.CurrentPlan}
						/> :
						<DialogContentText className='b-around-text-field-border-4 br-0_2 p-3 h-v-20 h6-regular d-flex justify-center align-center' id="alert-dialog-description">
							{appNote.NOCURRENTPLAN}
						</DialogContentText>
					}
				</DialogContent>
				<DialogActions className={`m-1`}></DialogActions>
			</Dialog> :
			<div>
				<div className='paper-background box-shadow-display-background-shadow d-flex w-fill p-2'>
					<span>{props.IsMobileDevice ? <BackMobileIcon className={"c-pointer pr-2"} onClick={props.HandleClose} /> : <BackIcon className={"c-pointer pr-2"} onClick={props.HandleClose} />}</span>
					<span className={`h1 d-inline-flex color-primary-accent mr-auto`}>{!!props.CurrentPlan ? DialogHeaders.PLAN_DETAILS : DialogHeaders.CURRENT_PLAN_DETAILS}</span>
				</div>
				<div className={`w-fill bg-color-current-plan-background o-x-hidden o-y-auto p-2 d-flex h-v-90 box-shadow-display-background-shadow`}>
					<div className="w-p-100 paper-background h-v-84 br-2 o-y-auto">
						<p className={`h3 px-2 color-text-field-font`}>{!!props.CurrentPlan ? DialogHeaders.PLAN_DETAILS : DialogHeaders.CURRENT_PLAN_DETAILS}</p>
						{!!props.CurrentPlan || !!props.CurrentAddons ?
							<PlanDetails currentPlan={props.CurrentPlan?.Plan} currentPhoneNumber={props.CurrentPhoneNumber}
								CurrentAddons={props.CurrentAddons}
								transactionHistory={props.CurrentPlan} IsMobileDevice={props.IsMobileDevice} /> :
							<div className='b-around-text-field-border-4 br-0_2 p-3 mx-3 h-v-20 h6-regular d-flex justify-center align-center' id="alert-dialog-description">
								{appNote.NOCURRENTPLAN}
							</div>}
					</div>
				</div>
			</div>
	);
}

export default CurrentPlanDetails;